export default __webpack_public_path__ + "static/media/action-card-staking.7ca2307b.svg";